export default __webpack_public_path__ + "static/media/sell1.a29af8ad.png";